<template>
    <div>
        <button
            type="button"
            @click="handleClick"
            @keyup.enter.prevent="handleEnter"
            :class="computedClasses"
            :disabled="loading || disabled"
            :id="buttonId"
        >
            {{ label }}
            <span class="inline ml-2" v-if="loading">
                <i class="fas fa-spinner-third fa-spin"></i>
            </span>
        </button>
    </div>
</template>

<script setup>
import { computed } from 'vue';
const emit = defineEmits(['clicked']);
const props = defineProps({
    label: String,
    loading: Boolean,
    classes: String,
    buttonId: String,
    useEnter: {
        type: Boolean,
        default: false,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
    error: {
        type: Boolean,
        default: false,
    },
});

const computedClasses = computed(() => {
    const errorClasses = props.error ? '!border-red-500' : '';

    return [props.classes, errorClasses].join(' ');
});

const handleEnter = (e) => {
    if (props.useEnter) {
        emit('clicked');
    }
};
const handleClick = () => {
    emit('clicked');
};
</script>
